export default __webpack_public_path__ + "static/media/pricingbg.db1de143.png";